<template>
    <div id="contactus">
      <NavBar :mainPage="mainPage"/>
      <section id="contact-intro" class="fullpage contact-intro" ref="lendingPartnerStart">
        <Lendingintro class="contact underlined-text" :heading="heading" />
    </section>
    
      <section id="contact-locations" class="fullpage mid contact-intro" >
        <Locations :locations="locations" />
      </section>
        <!-- Clickable Image Banner -->
        <section id="banner-section">
        <a :href="bannerLink" target="_blank">
          <img :src="bannerImage" alt="Clickable Banner" class="banner">
        </a>
      </section>
      <section id="contact-footer" class="fullpage" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
        <Footer id="foot" />
      </section>
    </div>
  </template>
  
  <script>
  import Lendingintro from "./lending-intro";
  import Locations from "./lenderDetails";
  
  export default {
    name: "ContactUs",
    components: {
      Locations,
      Lendingintro,
    },
    data() {
      return {
        mainPage: false,
        heading: "Our Lending Partners",
        bannerLink: "https://clos.icicibank.com/CAOOD/Apply.jsp?channelId=FT_Cash", // Replace with the actual URL
        bannerImage: require("@/assets/ICICI_InstaOD_Banners.jpg"), // Replace with your banner image
        paragraphs: {
          mapParagraph:
            "ftcash is one of India's fastest growing financial technology venture, recognized by Forbes, which aims to empower micro-merchants and small businesses through financial inclusion using digital payments and loans.",
          downloadParagraph:
            "Let ftcash app help you to get loans without any collateral requirements to build the business of your dreams",
        },
        locations: {
          locationIcon: "location-marker.png",
          callIcon: "call-icon.png",
          lenderName1: "FlexiLoans",
          lenderGrievanceRedressalOfficer1:
            "https://flexiloans.com/grievance-redressal-mechanism",
            lenderPrivacyPolicy1: "https://flexiloans.com/regulatory#ui-id-1",
            lenderProductDetails1: "https://flexiloans.com/regulatory#ui-id-1	https://flexiloans.com/",
          lenderImage1: "flexi_new_header.svg",

          lenderName2: "UGRO",
          lenderGrievanceRedressalOfficer2:
            "https://www.ugrocapital.com/front-assets/images/footer-doc/Grievance%20Redressal%20Mechanism.pdf",
            lenderPrivacyPolicy2: "https://www.ugrocapital.com/privacy-policy",
            lenderProductDetails2: "https://www.ugrocapital.com/",
          lenderImage2: "ugro.png",

          lenderName3: "PayU finance",
          lenderGrievanceRedressalOfficer3:
            "https://assets.payufin.com/docs/grievance-contact-details-20-Dec-2023.pdf",
            lenderPrivacyPolicy3: "https://www.payufin.in/privacy-policy",
            lenderProductDetails3: "https://www.payufin.in/",
          lenderImage3: "PayUFinance.svg",

          lenderName4: "Caspian Debt",
          lenderGrievanceRedressalOfficer4:
            "https://caspiandebt.in/compliance/",
            lenderPrivacyPolicy4: "https://caspiandebt.in/privacy-policy-2/",
            lenderProductDetails4: "https://caspiandebt.in/about/",
          lenderImage4: "caspian.png",

          lenderName5: "Northern Arc",
          lenderGrievanceRedressalOfficer5:
            "https://www.northernarc.com/grievance-redressal-mechanism",
            lenderPrivacyPolicy5: "https://www.northernarc.com/assets/uploads/pdf/Privacy-Policy.pdf",
            lenderProductDetails5: "https://www.northernarc.com/partnership-lending",
          lenderImage5: "northernArc.png",

          
          lenderName6: "Arthmate",
          lenderGrievanceRedressalOfficer6:
            "https://www.arthmate.com/helpTopic",
            lenderPrivacyPolicy6: "https://www.arthmate.com/helpTopic",
            lenderProductDetails6: "https://www.arthmate.com/",
          lenderImage6: "arthmate.webp",

          lenderName7: "Stashfin",
          lenderGrievanceRedressalOfficer7:
            "https://www.stashfin.com/grievance-redressal-mechanism",
            lenderPrivacyPolicy7: "https://www.stashfin.com/privacy-policy-akara",
            lenderProductDetails7: "https://www.stashfin.com/about-us",
          lenderImage7: "stashfin.png",

          lenderName8: "Gromor Finance",
          lenderGrievanceRedressalOfficer8:
            "https://gromor.in/contact-us",
            lenderPrivacyPolicy8: "https://gromor.in/legal/privacy-policy",
            lenderProductDetails8: "https://gromor.in/small-business-loan",
          lenderImage8: "gromor.png",
          lenderName9: "Credit Saison",
          lenderGrievanceRedressalOfficer9:
            "https://creditsaison.in/partnercontact/",
            lenderPrivacyPolicy9: "https://regulatory.creditsaison.in/privacy-policy",
            lenderProductDetails9: "https://creditsaison.in/",
          lenderImage9: "Credit_Saison.svg",
          lenderName10: "LENDINGKART",
          lenderGrievanceRedressalOfficer10:
            "https://www.lendingkart.com/privacy/",
            lenderPrivacyPolicy10: "https://www.lendingkart.com/privacy/",
            lenderProductDetails10: "https://www.lendingkart.com/",
          lenderImage10: "lendingKart.png",
          lenderName11: "Incred Finance",
          lenderGrievanceRedressalOfficer11:
            "https://www.incred.com/home/grievance/",
            lenderPrivacyPolicy11: "https://www.incred.com/home/privacy-policy/",
            lenderProductDetails11: "https://www.incred.com/home/",
          lenderImage11: "Incredfinance.jpg",

          lenderName12: "indifi",
          lenderGrievanceRedressalOfficer12:
            "https://www.indifi.com/contact",
            lenderPrivacyPolicy12: "https://www.indifi.com/privacy-policy",
            lenderProductDetails12: "https://www.indifi.com/associate/FTCash",
          lenderImage12: "indifi.png",

          //Protium
          lenderName13: "Protium",
          lenderGrievanceRedressalOfficer13:
            "https://protium.co.in/regulatory/grievance-redressal-policy/",
            lenderPrivacyPolicy13: "https://protium.co.in/regulatory/privacy-policy/",
            lenderProductDetails13: " https://protium.co.in/business-loan/",
          lenderImage13: "protium.png",
        },
      };
    },
    mounted() {
      
       this.$refs.lendingPartnerStart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
       //window.scrollTo(0, 0);
    },
    metaInfo() {
      return{
      link: [
        { rel: 'canonical', href: 'https://www.ftcash.com/lendingpartners' },
      ],
      }
    },
  };
  </script>
  
  <style scoped>
.banner {
  width: 100%;
  height: auto;
  max-width: 800px;
  display: block;
  margin: 20px auto;
}
section{
  min-height: 50vh;
}

@media (max-width: 1024px) {  /* iPads and Tablets */
  /* .banner {
    max-width: 900px;
    margin: 20px auto;

  }
  section{
  min-height: 10vh;
  } */
}

@media (max-width: 768px) {  /* Mobile devices */
  .banner {
    max-width: 600px;
  }
  section{
  min-height: 10vh;
  }
}

@media (max-width: 480px) {  /* Small Mobile devices */
  .banner {
    max-width: 100%;
  }
}
  .underlined-text {
    text-decoration: underline;
    color: rgb(186, 240, 218);
    /* border-width:5px;  /* Top, right, bottom, left */
    /* border-style: solid; */ 
}
  .contact-intro {
    background-image: url("../../assets/background/contact_form_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
     background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  
  section#contact-intro {
      min-height: 10vh;
      display: flex !important;
      flex-direction: column;
      justify-content: center;
      scroll-snap-align: center;
    }
  
  #left {
    transform: translate(10px, -48px);
  }
  
  
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    .contact-intro {
      height: 100vh;
    }
    #left {
      transform: none;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    section#contact-intro {
      min-height: 65vh;
    }
    section#contact-locations {
      margin: 2rem 0;
      min-height: 65vh;
    }
  }
  @media (min-width: 481px) and (max-width: 767px) {
    section#contact-intro {
      min-height: 75vh;
    }
    #left {
      transform: none;
    }
  }
  @media (max-width: 480px) {
    
    .mid {
      padding: 10% 0;
    }
  }
  @media (min-width:820px) and (max-width: 820px) {
      #foot{
      margin-top: 80%;
    }
  }
  </style>
  